import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import Box from "@mui/material/Box";
import { formatDate } from "../../constants/helper";

interface MuiDatePickerProps {
  value: Dayjs | null;
  label?: string;
  disabled?: boolean;
  onChange: (date: string) => void;
  isError?: boolean;
  errorText?: string;
  isDisablePastDate?: boolean;
  onBlur?: () => void;
  isRequired?: boolean;
  placeholder?: string;
  minDate?: Dayjs;
}

const MuiDatePicker: React.FC<MuiDatePickerProps> = ({
  value,
  label,
  disabled = false,
  onChange,
  errorText = "",
  isError = false,
  isDisablePastDate = true,
  onBlur,
  isRequired = false,
  placeholder,
  minDate,
}) => {
  const dateChange = (selectedDate: any) => {
    const formattedDate = formatDate(selectedDate);
    onChange(formattedDate);
  };

  const renderLabel = () => (
    <>
      {label}
      {isRequired && <span style={{ color: "red" }}> *</span>}
    </>
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ maxWidth: "100%", width: "100%" }}>
        <DatePicker
          label={!placeholder ? renderLabel() : undefined}
          value={dayjs(value).isValid() ? value : null}
          onChange={(date) => dateChange(date)}
          minDate={minDate ?? (isDisablePastDate ? dayjs() : undefined)}
          disabled={disabled}
          slotProps={{
            textField: {
              fullWidth: true,
              placeholder: placeholder || "",
              error: Boolean(isError && errorText), // ✅ Show red border only if error + errorText
              helperText: isError ? errorText : "", // ✅ Show helper text conditionally
              onBlur: onBlur ?? (() => {}),
            },

            desktopPaper: {
              sx: {
                maxWidth: "100vw",
                width: "100%",
                minWidth: "300px",
              },
            },
            dialog: {
              sx: {
                "& .MuiDialog-paper": {
                  margin: "16px",
                  borderRadius: "12px",
                  padding: "16px",
                },
                "& .MuiPickersCalendarHeader-root": {
                  justifyContent: "space-between",
                },
                "& .MuiTypography-root": {
                  fontSize: "1rem",
                },
              },
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default MuiDatePicker;
